import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getStudentID } from 'selectors/ui/ui';
import { cookies } from 'utils/cookies/cookies';
import { experiments } from '../../services/payex/experiments/experiments';

type TrackEventParams = {
  eventName: string;
  eventProperties?: Record<string, string | boolean | number>;
  userId?: string;
  userEmail?: string;
};

type TrackEventResponse = void;

export const useExperimentTrack = (
  opts: UseMutationOptions<TrackEventResponse, unknown, TrackEventParams> = {},
): ((params: TrackEventParams) => void) => {
  const studentId = useSelector(getStudentID) as string;
  const fingerprint = cookies.read(PERMANENT_COOKIE_NAME);

  const { mutate } = useMutation<TrackEventResponse, unknown, TrackEventParams>(
    (params: TrackEventParams) => {
      const resolvedUserId =
        params.userId || fingerprint || studentId || undefined;
      return experiments.trackEvent(
        params.eventName,
        params.eventProperties,
        resolvedUserId,
        params.userEmail,
      );
    },
    opts,
  );

  return (params: TrackEventParams) => mutate(params);
};
